import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import "./styles/index.css";   

import {
  JobListings,
  Carrers,
  JobListView,
  JobDetail,
  UserLogin,
  UserRegister,
  Generalquestions,
  Education,
  WorkEligibilty,
  Resume,
  Acknowledge,
  VoluntaryEqual,
  VoluntarySelf,
  ReveiwSubmit,
  Culture,
  Support,
  Diversity,
  LeaderShip,
  JobCategory,
  JobTeam,
  Blogs,
  Blog,
  NotFound,
  CertificateValidation,
} from "./Pages";

// Lazy-load the HiringTips page to reduce initial bundle size
const HiringTipsLazy = React.lazy(() => import("./Pages/HiringTips"));

// Include the new routes
const routes = [
  { path: "/carrer", element: <Carrers /> },
  { path: "/", element: <Carrers /> },
  { path: "/joblistings", element: <JobListings /> },
  { path: "/joblistings/View", element: <JobListView /> },
  { path: "/sign-in", element: <UserLogin /> },
  { path: "/sign-up", element: <UserRegister /> },
    { path: "/jobs/:id", element: <JobDetail /> },
  { path: "/generalquestions", element: <Generalquestions /> },
  { path: "/education", element: <Education /> },
  { path: "/workEligibilty", element: <WorkEligibilty /> },
  { path: "/resume", element: <Resume /> },
  { path: "/acknowledge", element: <Acknowledge /> },
  { path: "/voluntaryEqual", element: <VoluntaryEqual /> },
  { path: "/voluntarySelf", element: <VoluntarySelf /> },
  { path: "/reveiwSubmit", element: <ReveiwSubmit /> },
  { path: "/culture", element: <Culture /> },
  { path: "/support", element: <Support /> },
  { path: "/diversity", element: <Diversity /> },
  { path: "/leadership", element: <LeaderShip /> },
  { path: "/jobcategory", element: <JobCategory /> },
  { path: "/jobteam", element: <JobTeam /> },
  { path: "/blogs", element: <Blogs /> },
  { path: "/blog/:id", element: <Blog /> },
  {
    path: "/hiring-tips",
    element: (
      <React.Suspense fallback={<div className="p-6 text-center">Loading...</div>}>
        <HiringTipsLazy />
      </React.Suspense>
    ),
  },
  { path: "/certificate-validation", element: <CertificateValidation /> },
  { path: "*", element: <NotFound /> },
  { path: "/login", element: <UserLogin /> },
  
  // Add the new routes here
  { path: "/careers", element: <Carrers /> },
];

const App = () => {
  const location = useLocation();

  useEffect(() => {
    localStorage.setItem("myPath", location.pathname);
  }, [location.pathname]);

  return (
    <>
      <Routes>
        {routes.map(({ path, element }, index) => (
          <Route key={index} path={path} element={element} />
        ))}
      </Routes>
    </>
  );
};

const WrappedApp = () => (
  <Router>
    <App />
  </Router>
);

export default WrappedApp;
